import useAuth from "@/hooks/useAuth";
import { Circle } from "@mui/icons-material";
import {
    Chip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TableContainer
  } from "@mui/material";
import { useAuthenticationsForEmailRequest, useAuthenticationsRequest } from "apiRequests/usersAuthentications";
import { User } from "lucide-react";
import {DateTime} from "luxon";
import { useParams } from "react-router-dom";

const Authentications = () => {
    const {user} = useAuth()
    const params = useParams()
    
    const email = params.email
    const { data, loading, error }  = useAuthenticationsForEmailRequest(user, {email})


    return (
        <TableContainer component={Paper} style={{ overflowX: 'auto' }}>
            <Table stickyHeader style={{ minWidth: 800 }}>
            <TableHead>
                <TableRow>
                    <TableCell>User</TableCell>
                    <TableCell >IP Address</TableCell>
                    <TableCell>Location</TableCell>
                    <TableCell>Attempt At</TableCell>
                    <TableCell>Attempt Status</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data?.map((row) =>{
                    let color : "color" | "success" | "error" = "success"
                    if(row.success){
                        color = "success"
                    }else{
                        color = "error"
                    }
                    const status = row.success ? "success" : "failed"
                    
                    let location : string | undefined = "N/A"
                    if (row.locations && row.locations.length > 0){
                        location = extractLocation(row.locations)
                    }

                    return  (
                        <TableRow key={row.id}>
                            <TableCell>
                                <div style={{float: "left", display: "flex", width: "3em", height: "3em", borderRadius: "50%", backgroundColor: "#efefef", alignItems: "center", justifyContent: "center"}}>
                                    <User color="#aabbff" />
                                </div>
                                <div style={{verticalAlign: "middle", paddingLeft: 60}}>
                                    <div>
                                        {row.firstName}&nbsp;{row.lastName}
                                    </div>
                                    {row.email}
                                </div>
                            </TableCell>
                            <TableCell>{row.ipAddress}</TableCell>
                            <TableCell>
                                {location}
                            </TableCell>
                            <TableCell>{DateTime.fromISO(row.createdAt).toFormat("h:mma - d LLL yyyy")}</TableCell>
                            <TableCell>
                                <Chip label={<div><Circle style={{fontSize: 8, verticalAlign: "middle"}} /> {status}</div>} color={color} size="small" style={{borderRadius: 15}} variant="outlined" />
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
            </Table>
        </TableContainer>
    );
}
export default Authentications;


const extractLocation = (locations: {
        country: string
        city: string
        latitude: number
        longitude: number
}[]) => {
    for (const location of locations) {
        const loc: string[] = [];
        if (location.latitude) loc.push(location.latitude.toString());
        if (location.longitude) loc.push(location.longitude.toString());
        if (location.city) loc.push(location.city);
        if (location.country) loc.push(location.country);
        if (loc.length > 0) {
            return loc.join(", ");
        }
    }
}